import { PropsWithChildren, useMemo } from 'react';
import { newId } from '@petconsole/pure-base';
import { ExtendedFormik } from '@petconsole/pure-shared';

interface FormikFragmentProps extends PropsWithChildren {
  formik: ExtendedFormik;
  readOnly?: boolean;
}

const FormikFragment = ({ formik, readOnly, children }: FormikFragmentProps) => {
  const key = useMemo(() => newId(), []);

  if (!children) return null;
  if (!Array.isArray(children)) return children;

  return (
    <>
      {children.map((Child, index) => {
        if (typeof Child !== 'object') return Child;

        return { ...Child, props: { ...Child.props, key: `${key}-${index}`, formik, readOnly }};
      })}
    </>
  );
};

FormikFragment.whyDidYouRender = true;

export default FormikFragment;
